import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()(() => ({
	numericFont: { fontVariantNumeric: 'tabular-nums' },
}));
